/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Unknown7Inputs */

const en_cv_extract_form_enum_unknown7 = /** @type {(inputs: Cv_Extract_Form_Enum_Unknown7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const de_cv_extract_form_enum_unknown7 = /** @type {(inputs: Cv_Extract_Form_Enum_Unknown7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannt`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Cv_Extract_Form_Enum_Unknown7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_unknown7 = /** @type {((inputs?: Cv_Extract_Form_Enum_Unknown7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Unknown7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_unknown7(inputs)
	return en_cv_extract_form_enum_unknown7(inputs)
});
export { cv_extract_form_enum_unknown7 as "cv_extract_form_enum_UNKNOWN" }